module.exports = __webpack_public_path__ + "img/ss5 copy.aeadd25f.png";